// extracted by mini-css-extract-plugin
export default {"content":"BayarPesanan_content__2FqRn","titleGroup":"BayarPesanan_titleGroup__C56kQ"};